import {
  Document,
} from '../../../../types/models';
import SynchronousDocumentOperation from './synchronous';

export default class SetGradeLevelOperation extends SynchronousDocumentOperation {
  readonly type = 'set-grade-level';

  gradeLevel: string;

  constructor(documentId: string, gradeLevel: string) {
    super(documentId);
    this.gradeLevel = gradeLevel;
  }

  apply(document: Document): Document {
    return {
      ...document,
      meta: {
        ...document.meta,
        gradeLevel: this.gradeLevel,
      },
    };
  }
}
